export default __webpack_public_path__ + "static/media/No.0-1.4a01563a.jpg";